import React, { useState } from "react";
import {
  Container,
  Row,
  Col,
  Table,
  ButtonDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import PageHeader from "../../Component/BasicComponents/HeaderBreadCrumbs";
import RoundedDropdown from "../../Component/BasicComponents/Dropdowns/RoundedDropdown";

const ExpensesSlip: React.FC = () => {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const toggle = () => setDropdownOpen((prevState) => !prevState);

  return (
    <div className="p-2">
      <PageHeader
        title="Expenses Slip"
        buttons={[
          {
            label: "Excel",
            onClick: () => alert("Download Excel"),
            color: "#43B9B2",
          },
          {
            label: "CSV",
            onClick: () => alert("Download CSV"),
            color: "#43B9B2",
          },
        ]}
      />
      <div className="my-4 p-4 rounded bg-white" style={{backgroundColor:'#ffffff',border:'0.01px solid #ecf0f1'}}>
        <Row className="mb-3">
          <Col xs="9">
            <h4>Expense Report</h4>
          </Col>
          <Col
            md="3"
            className="d-flex justify-content-end align-items-center gap-2"
          >
            <RoundedDropdown
              options={[]}
              onSelect={(e) => console.log("status", e)}
              defaultLabel="All"
              width="120px"
              isShowHeading
              DropdownHeading="Month"
              headingColor="#2e8dd3"
            />
          </Col>
        </Row>

        <Table bordered className="text-capitalize">
          <thead>
            <tr>
              <th colSpan={6} className="text-center">
                Expense Report | March 2025
              </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>
                <strong>Employee Name</strong>
              </td>
              <td colSpan={5}>sachin kadam</td>
            </tr>
            <tr>
              <td>
                <strong>Employee Code</strong>
              </td>
              <td>001</td>
              <td>
                <strong>Designation</strong>
              </td>
              <td>CMD</td>
              <td>
                <strong>State</strong>
              </td>
              <td></td>
            </tr>
            <tr>
              <td>
                <strong>Head Quarter/ Location</strong>
              </td>
              <td colSpan={5}>Head Office |</td>
            </tr>
            <tr>
              <td>
                <strong>Currency</strong>
              </td>
              <td colSpan={5}></td>
            </tr>
          </tbody>
        </Table>

        <Table bordered>
          <thead>
            <tr>
              <th>Budget</th>
              <th>Purpose</th>
              <th>Basic Amount</th>
              <th>Total Amount</th>
              <th>Deduction by Approver</th>
              <th>Net Payable Amount</th>
              <th>Company Card</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td colSpan={7} style={{ height: "50px" }}></td>
            </tr>
            <tr>
              <td>
                <strong>Total</strong>
              </td>
              <td colSpan={6}></td>
            </tr>
          </tbody>
        </Table>

        <Row className="mt-3">
          <Col xs="6">
            <strong>Net Payable Amount ()</strong>
          </Col>
          <Col xs="6" className="text-end">
            <strong>Signature</strong>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default ExpensesSlip;
